import api from "../../config/api";

const state = {
  locationBalance: null,
  organizationBalance: null,
};

const mutations = {
  setLocationBalance(state, payload) {
    state.locationBalance = payload;
  },
  setOrganizationBalance(state, payload) {
    state.organizationBalance = payload;
  },
};

const actions = {
  async fetchLocationBalance({ commit }, locationId) {
    try {
      const response = await api.get(`/billing/location-balance/${locationId}`);
      const result = response?.data ?? null;
      commit("setLocationBalance", result);
      return result;
    } catch (error) {
      console.error("Error fetching location balance:", error);
      throw error;
    }
  },
  async fetchOrganizationBalance({ commit }, organizationId) {
    try {
      const response = await api.get(`/billing/organization-balance/${organizationId}`);
      const result = response?.data ?? null;
      commit("setOrganizationBalance", result);
      return result;
    } catch (error) {
      console.error("Error fetching organization balance:", error);
      throw error;
    }
  },
};

const getters = {
  stLocationBalance: (state) => state.locationBalance,
  stOrganizationBalance: (state) => state.organizationBalance,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
